import _equals from "ramda/es/equals";
import _ from "ramda/es/__";
import _join from "ramda/es/join";
import _map from "ramda/es/map";
import _pipe from "ramda/es/pipe";
import _toUpper from "ramda/es/toUpper";
import _compose from "ramda/es/compose";
import _test from "ramda/es/test";
import _when from "ramda/es/when";
import removeSpaces from './removeSpaces';
import moveCharsToEnd from './moveCharsToEnd';
import stringModulo from './stringModulo';

var toDigit = _when(_test(/[A-Za-z]/), _compose(function (char) {
  return "".concat(char.charCodeAt(0) - 55);
}, _toUpper));

export default _pipe(removeSpaces, moveCharsToEnd(4), _map(toDigit), _join(''), stringModulo(_, 97), // eslint-disable-line no-underscore-dangle
_equals(1));